import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AuthStore } from '@store';

import { MatIconModule } from '@angular/material/icon';
import { ViIconButtonComponent } from '../../../projects/ui';
import { CommonStandaloneModule } from '../common-standalone.module';
import { ServiceTicketService } from './service-ticket.service';

@Component({
  selector: 'app-service-ticket',
  templateUrl: './service-ticket.component.html',
  styleUrls: ['./service-ticket.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonStandaloneModule, MatIconModule, ViIconButtonComponent],
})
export class ServiceTicketComponent {
  constructor(public authStore: AuthStore, public serviceTicketService: ServiceTicketService) {}

  openOverlay(): void {
    this.serviceTicketService.openOverlay();
  }
}
